/* Pasek newslettera w stopce - zapis wprost do Klaviyo.

   Formularz w markupie zostaje natywnym formularzem klienta Shopify, wiec bez
   tego skryptu (albo bez wpisanych danych Klaviyo) dziala po staremu: adres
   laduje w Klientach sklepu z tagiem "newsletter". Skrypt przechwytuje
   wyslanie i zamiast przeladowania strony robi zapytanie do Klaviyo, dzieki
   czemu powitalna wiadomosc z kodem rabatowym rusza od razu, a klient zostaje
   na stronie.

   Gdy Klaviyo nie odpowie, formularz idzie natywnie - adres nie przepada.
   Inicjalizacja takze na shopify:section:load, bo edytor motywu podmienia HTML
   sekcji bez odswiezenia strony. */
(function () {
  var REVISION = '2024-10-15';

  function init(root) {
    var forms = root.querySelectorAll('[data-klaviyo-form]');
    for (var i = 0; i < forms.length; i++) setup(forms[i]);
  }

  function setup(form) {
    if (form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';

    var company = form.getAttribute('data-klaviyo-company');
    var list = form.getAttribute('data-klaviyo-list');
    if (!company || !list) return;

    var field = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var note = form.querySelector('[data-newsletter-note]');
    if (!field || !button) return;

    var teksty = {
      sending: form.getAttribute('data-text-sending') || '',
      success: form.getAttribute('data-text-success') || '',
      error: form.getAttribute('data-text-error') || ''
    };

    function pokaz(tekst, stan) {
      if (!note) return;
      note.textContent = tekst;
      note.setAttribute('data-state', stan);
      note.hidden = tekst === '';
    }

    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) return;
      event.preventDefault();

      button.disabled = true;
      pokaz(teksty.sending, 'sending');

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                /* Jezyk strony, z ktorej klient sie zapisal (pl/nl/de/en) - po nim
                   automatyzacja powitalna w Klaviyo wybiera wersje maila (warunek „locale starts with de/en”);
                   bez niego kazdy dostawal wersje niderlandzka (26.10.2026). */
                attributes: { email: field.value, properties: { locale: form.getAttribute('data-klaviyo-language') || '' } }
              }
            },
            custom_source: form.getAttribute('data-klaviyo-source') || 'Newsletter'
          },
          relationships: {
            list: { data: { type: 'list', id: list } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: REVISION },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('klaviyo ' + response.status);
          button.disabled = false;
          field.value = '';
          pokaz(teksty.success, 'success');
        })
        .catch(function () {
          /* Adres nie moze przepasc: puszczamy formularz natywnie, wiec
             subskrybent trafia przynajmniej do Klientow sklepu, a Klaviyo
             zaciagnie go swoja synchronizacja. */
          pokaz(teksty.error, 'error');
          form.dataset.ready = 'fallback';
          form.submit();
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState !== 'loading') init(document);
})();
